import { ButtonProps, IconProps } from '@amzn/awsui-components-core';
import { ContentWorkflow, WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import FlashbarMessageBroker from '../../common/FlashbarMessageBroker';
import ModalDialogButtonV3 from '../common/ModalDialogButtonV3';

interface Props {
  workflow: ContentWorkflow;
  onDeleteContent?: () => void;
  variant?: 'normal' | 'primary' | 'icon' | 'text' | 'link';
  buttonText?: string;
  iconName?: IconProps.Name | null;
  iconUrl?: string | null;
  iconAlign?: ButtonProps.IconAlign;
}

class DeleteContentButton extends React.Component<Props> {
  private static defaultProps: Props = {
    workflow: new ContentWorkflow(),
  };

  private mplServiceClient: IMplServiceClient;
  private flashbarMessageBroker: FlashbarMessageBroker;

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.mplServiceClient = MplServiceClientFactory.create();
    this.flashbarMessageBroker = FlashbarMessageBroker.create();
  }

  public render() {
    const { variant, iconUrl, iconName, iconAlign, buttonText } = this.props;
    const { draftState, publicationState } = this.props.workflow;

    if (
      (publicationState && publicationState !== WorkflowState.UNPUBLISHED) ||
      [WorkflowState.REVIEWED].includes(draftState)
    ) {
      return null;
    }

    return (
      <ModalDialogButtonV3
        variant={variant}
        iconUrl={iconUrl}
        iconAlign={iconAlign}
        iconName={iconName}
        buttonText={buttonText}
        header={constants.DELETE_CONTENT_HEADER_TEXT}
        text={constants.DELETE_CONTENT_MODAL_TEXT}
        submitButtonText={constants.DELETE_CONTENT_BUTTON_TEXT}
        onSubmit={this.deleteContent}
      />
    );
  }

  private deleteContent = async () => {
    const { workflow, onDeleteContent } = this.props;

    await this.mplServiceClient.deleteContent(workflow.contentId);

    this.flashbarMessageBroker.pushSuccessMessage('Content Deleted. Please refresh the page.');
    if (onDeleteContent) {
      onDeleteContent();
    }
  };
}

export default DeleteContentButton;
